import React, { useEffect } from "react"
import { Routes, Route } from "react-router-dom"
import LoadingScreen from "./LoadingScreen"
// import { ContextProvider } from "./context/ContextProvider"
import axios from "axios"
import { baseApi } from "./config"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import ProtectedClientRoutesWrapper from "./router/ClientRouter"
import { useDemo } from "./context/DemoContext"
import DesktopOnlyOverlay from "./components/DesktopOnlyOverlay"
import DemoEmailOverlay from "./components/DemoEmailOverlay"

import "./App.css"
import "./components/Buttons/Button.css"
import "./css/ClientSelectorPage.css"
import "./css/Organization.css"

// function ProtectedRoute({ children }) {
//   const token = localStorage.getItem("authToken");
//   return token ? children : <Navigate to="/" />;
// }

function App() {
  const { demoLoading, hasDemoAccess } = useDemo()

  const env = process.env.REACT_APP_ENV

  if (demoLoading) {
    console.log("here")
    return <LoadingScreen h1="Checking demo access..." />
  }

  return (
    <>
      {!hasDemoAccess && <DemoEmailOverlay />}
      {hasDemoAccess && <DesktopOnlyOverlay />}

      <ToastContainer position="top-right" autoClose={3000} />

      <Routes>
        <Route path="/*" element={<ProtectedClientRoutesWrapper />} />
      </Routes>
      {/* 👇 Faded staging label */}
      {env === "staging" && (
        <div
          style={{
            position: "fixed",
            bottom: "8px",
            left: "50%",
            transform: "translateX(-50%)",
            background: "rgba(0, 0, 0, 0.4)",
            color: "white",
            fontSize: "12px",
            padding: "4px 10px",
            borderRadius: "8px",
            opacity: 0.6,
            zIndex: 9999,
          }}
        >
          Staging Environment
        </div>
      )}
      {/* 👇 Faded development label */}
      {env === "development" && (
        <div
          style={{
            position: "fixed",
            bottom: "8px",
            left: "50%",
            transform: "translateX(-50%)",
            background: "rgba(0, 0, 0, 0.4)",
            color: "white",
            fontSize: "12px",
            padding: "4px 10px",
            borderRadius: "8px",
            opacity: 0.6,
            zIndex: 9999,
          }}
        >
          Development Environment
        </div>
      )}
    </>
  )
}

export default App
